export default {
    page_title: "Kevi | Informe General",
    title: "Informe General",
    stats: {
        clients: "Clientes",
        orders: "Pedidos",
        total_income: "Ingresos totales",
        avg_ticket: "Ticket promedio",
        avg_time_between_orders: "Tiempo promedio entre pedidos",
        incentivized_income: "Ingresos incentivados",
        base_clients: "Clientes de la Base ({0}%)",
        days_suffix: "dias",
    },
    pie_chart: {
        first_time: "Primera Vez",
        returned: "Regresaron",
    },
    downloads: {
        orders_aria_label: "Descargar archivo con datos de los pedidos",
        orders_tooltip: "Descargar pedidos",
        incentivized_orders_aria_label:
            "Descargar archivo con datos de los pedidos incentivados",
        incentivized_orders_tooltip: "Descargar incentivados",
    },
    filters: {
        first_order_period: "Periodo del primer pedido",
        client_segments: "Segmento del cliente",
        order_status: "Estado del pedido",
    },
    states: {
        empty: "No hay datos suficientes para el periodo seleccionado",
    },
    charts: {
        orders_and_income_by: "Pedidos e Ingresos por",
        average_by: "Promedio por",
        retention_curve: "Curva de Retención",
        income_by_field: "Ingresos por {0}",
        group_by: "Agrupar por:",
    },
    chart_axes: {
        orders: "Pedidos",
        income: "Ingresos",
        client_percentage: "% de Clientes",
        orders_in_period: "Pedidos en el periodo",
    },
    tooltips: {
        clients_percentage: "{0}% ({1} clientes)",
        not_informed: "No informado",
    },
};
